module.exports = __webpack_public_path__ + "490c8ea06ddd52ce2b5d02e17b41c987.png";